module.exports = __webpack_public_path__ + "img/footer_logo.deb069d8.png";